import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App.jsx';
import { AuthProvider } from './state/AuthContext.jsx';
import { MetaProvider } from './state/MetaContext.jsx';
import { ToastProvider } from './state/ToastContext.jsx';
import { registerServiceWorker } from './lib/pwa.js';
import './styles.css';
import './styles-management.css';
import './styles-theme.css';

// Makes the app installable and lets it open when the connection has gone.
registerServiceWorker();

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <MetaProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </MetaProvider>
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>
);
